interface ChevronDownIconProps {
  isOpen?: boolean;
}

export const ChevronDownIcon = ({ isOpen = false }: ChevronDownIconProps) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transition: 'transform 0.2s',
      transform: isOpen ? 'rotate(180deg)' : 'none',
      display: 'block',
    }}
  >
    <path d="M5.87793 7.5L10.8779 12.5L15.8779 7.5" stroke="#737373" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
